export const camelCaseToSentenceCase = str =>
  str
    .replace(/[_-]([^_-])/g, function ($0, $1) {
      return $1.toUpperCase();
    }) //convert underscore to sentence
    .replace(/([A-Z])/g, match => ` ${match}`)
    .replace(/^./, match => match.toUpperCase())
    .trim(); //convert str = 'lastName' to 'Last Name'

export const numberToCurrency = num =>
  `$${num
    .toFixed(2)
    .toString()
    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}`;

//converts normal string number to a monetery value string, e.g. converting "100000" to "$ 100,000"
export const formatToMoney = value => {
  return `$${Number(value).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

//parses number from monetery value string, e.g. converting "$ 100,000" to "100000"
export const parseMoneyString = value => {
  return value.replace(/\$\s?|(,*)/g, "");
};

export const camelize = str => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};

export const toTitleCase = str => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

// If we generate a URL from a company name that contains special characters,
// it may break the generated Cloudflare URL. Replace all non-alphanumeric characters with an underscore.
export function sanitizeForUrl(str) {
  return str.replace(/[^a-zA-Z0-9]/g, "_");
}

export const minifyHtml = html => {
  return html
    .replace(/\r\n|\n|\t/g, " ")
    .replace(/> *</g, "><")
    .replace(/"/g, "'");
};

// Generates a unique string based on a random suffix
// Used to create unique identifiers for content where caching might be an issue
export const makeUniqueString = (str, fallback = "content") => {
  const randomSuffix = Math.random().toString(36).substring(2, 8);
  const uniqueStringName = str
    ? `${str}_${randomSuffix}`
    : `${fallback}_${randomSuffix}`;
  return uniqueStringName;
};
